var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "23px",
    viewBox: "0 0 42 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5C3107AC-36B6-42BD-AA32-F5DA5D30C467") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAQ-Page",
    transform: "translate(-1156.000000, -504.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-line-copy-4",
    transform: "translate(1177.000000, 1420.000000) scale(1, -1) translate(-1177.000000, -1420.000000) translate(1156.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3403968,1831.32466 C20.2543649,1832.22511 21.7322708,1832.22511 22.6365158,1831.32466 L41.3145239,1812.93232 C42.228492,1812.03186 42.228492,1810.5758 41.3145239,1809.68492 C40.4005558,1808.79404 38.9226499,1808.78446 38.0184048,1809.68492 L21.0030409,1826.44877 L3.97795389,1809.67534 C3.06398577,1808.77489 1.58607987,1808.77489 0.681834815,1809.67534 C-0.22241024,1810.5758 -0.232133305,1812.03186 0.681834815,1812.92274 L19.3403968,1831.32466 Z",
    id: "COLLAPSE-CHEVRON"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.74f44773ff4965a5ae6182b2229de4a7.svg";
export { ForwardRef as ReactComponent };